module.exports = __webpack_public_path__ + "assets/sofort-ueberweisung-w.b3914797.png";